
import { oz } from '@weft/utils';
import { JWT_PATTERN, NUM_OF_JWT_PARTS } from './jwt-schema-consts';

function validateJWtSchema(token: string) {
  const parts = token.split('.');

  return parts.length === NUM_OF_JWT_PARTS && parts.every(part => JWT_PATTERN.test(part));
}

export const JwtSchema = oz
  .string()
  .refine(validateJWtSchema, 'Must be a valid JWT')
  .openapi('Jwt');
